import { Emojis } from '~/types';

export const completeEmojis = (emojis: Emojis[]) => {
  const EMOJI_TYPES = ['like', 'cool', 'surprise', 'tough', 'angry', 'money'];

  // 기존 이모지를 emoji_type을 키로 하는 객체로 변환
  const existingEmojis: { [key: string]: Emojis } = emojis.reduce(
    (acc, emoji) => {
      acc[emoji.emoji_type] = emoji;
      return acc;
    },
    {} as { [key: string]: Emojis },
  );

  // 모든 이모지 타입에 대해 객체 생성
  return EMOJI_TYPES.map((type, index) => {
    if (existingEmojis[type]) {
      // 기존 이모지가 있으면 그대로 반환
      return existingEmojis[type];
    } else {
      // 기존에 없는 이모지는 새로운 emoji_id와 함께 추가
      return {
        emoji_id: index + 1, // emoji_id를 1부터 6까지 순서대로 설정
        emoji_type: type,
        count: 0,
        is_clicked: false,
      };
    }
  });
};
